<template>
  <div>
    <span>Select gender:<select id="retire_gender"></select></span><br />
    <svg id="retirement_age_chart" style="background-color: white"></svg>
  </div>
</template>


<script>
import * as d3 from "d3";
export default {
  name: "RetireAge",
  data: function () {
    return {
      svg_retire_agr_bar: null,
      margin_retire_age_bar: null,
      width_retire_age: 1000,
      height_retire_age: 500,
      width: 1000,
      height: 500,
      color_for_male_bar: "#DFE6B0",
      color_for_female_bar: "#FFD5AC",
      data_retire_age_by_country: null,
      current_select_gender: "male",
      //   retire_years:[],
      //   gender: null,
      option: null,
      x: null,
      y: null,
      xAxis: null,
      yAxis: null,
      data: null,
      bar_text: null,
      bar: null,
      select_mode: null,
      draw_speed: 3,
    };
  },
  created() {},
  mounted() {
    this.svg_retire_agr_bar = d3
      .select("#retirement_age_chart")
      .attr("viewBox", `0 0 1000 500`);

    (this.margin_retire_age_bar = { top: 30, right: 3, bottom: 20, left: 40 }),
      (this.width_retire_age =
        1000 -
        this.margin_retire_age_bar.left -
        this.margin_retire_age_bar.right);
    this.height_retire_age =
      500 - this.margin_retire_age_bar.top - this.margin_retire_age_bar.bottom;

    //   console.log("width",this.width_retire_age)

  // add title
    this.svg_retire_agr_bar
      .append("text")
      .style("text-anchor", "middle")
      .style("font-size", "20")
      .style("opacity", "0.7")
      .attr("x", this.width / 2 - 20)
      .attr("y", "18")
      .style("font-weight", "700")
      .text("Retire Age from 1990 to 2018");


      // add y axis label
          this.svg_retire_agr_bar.append("text")
    .style("text-anchor", "end")
        .style("font-size", "13")
        .style("opacity","0.7")
        .attr("x",this.margin_retire_age_bar.left -70)
        .attr("y",10)
        .attr("transform", "rotate(-90)")
        // .style("font-weight","700")
        .text("Age")

    this.loadRetireAge();
    // this.draw_retire_age_bar_chart(
    //   "male",
    //   //   this.current_retire_data,
    //   3
    // );

    this.gender = ["male", "female"];
    this.options = d3
      .select("#retire_gender")
      .selectAll("option")
      .data(this.gender)
      .enter()
      .append("option")
      .text((d) => d);

    const genderSelector = d3.select("#retire_gender");

    d3.select("#retire_gender").on("change", () => {
      //console.log('genderSelector !!!!!!!!!! is ',genderSelector.property('value'))
      this.current_select_gender = genderSelector.property("value");
      // console.log('on select :',this.current_select_gender)
      this.draw_retire_age_bar_chart();
    });
  },
  methods: {
    loadRetireAge() {
      const API = this.$store.state.API;
      //   d3.csv(`${API}/affect/laborMarket/labor_ratio_1991.csv`).then((d) => {
      d3.csv(`${API}/affect/laborMarket/retirement_age.csv`).then((csv) => {
        this.data_retire_age_by_country = [
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
        ];

        //   var retire_years = [];

        csv.forEach(function (d) {
          // d.country = d.country;
          // d.gender = d.gender;
          d.year = +d.year;
          d.value = +d.value;
          return d;
        });

        // console.log("csv is",csv)
        //   for csv.forEach(function (d) {
        for (var d of csv) {
          //   console.log("d is ",d)
          if (d.country === "Japan") {
            //   this.retire_years.push(d.year);
            this.data_retire_age_by_country[0].push(d);
          } else if (d.country === "Italy") {
            this.data_retire_age_by_country[1].push(d);
          } else if (d.country === "France") {
            this.data_retire_age_by_country[2].push(d);
          } else if (d.country === "Spain") {
            this.data_retire_age_by_country[3].push(d);
          } else if (d.country === "United Kingdom") {
            this.data_retire_age_by_country[4].push(d);
          } else if (d.country === "Canada") {
            this.data_retire_age_by_country[5].push(d);
          } else if (d.country === "United States") {
            this.data_retire_age_by_country[6].push(d);
          } else if (d.country === "Australia") {
            this.data_retire_age_by_country[7].push(d);
          } else if (d.country === "China") {
            this.data_retire_age_by_country[8].push(d);
          } else if (d.country === "Turkey") {
            this.data_retire_age_by_country[9].push(d);
          } else if (d.country === "Mexico") {
            this.data_retire_age_by_country[10].push(d);
          } else if (d.country === "Finland") {
            this.data_retire_age_by_country[11].push(d);
          } else if (d.country === "Iceland") {
            this.data_retire_age_by_country[12].push(d);
          } else if (d.country === "Chile") {
            this.data_retire_age_by_country[13].push(d);
          }
        }
        //   );

        // console.log('data is', data_retire_age_by_country)
        // draw_pie_chart_1991();
        // console.log("year",retire_years)

        // console.log("data is ", this.data_retire_age_by_country);
        //draw x & y axis
        this.svg_retire_agr_bar.append("g").attr("class", "x-axis");
        this.svg_retire_agr_bar.append("g").attr("class", "y-axis");

        this.current_retire_data = this.data_retire_age_by_country[0];
        // this.current_retire
        this.draw_speed = 750;
        this.draw_retire_age_bar_chart();
      });
    },

    draw_retire_age_bar_chart() {
      // console.log("current current_retire_data is", this.current_retire_data);

      this.x = d3
        .scaleBand()
        .range([
          this.margin_retire_age_bar.left,
          this.width_retire_age - this.margin_retire_age_bar.right,
        ])
        .padding(0.1)
        .paddingOuter(0.2);

      this.y = d3
        .scaleLinear()
        .range([
          this.height_retire_age - this.margin_retire_age_bar.bottom,
          this.margin_retire_age_bar.top,
        ]);

      this.xAxis = (g) =>
        g
          .attr(
            "transform",
            "translate(0," +
              (this.height_retire_age - this.margin_retire_age_bar.bottom) +
              ")"
          )
          .call(d3.axisBottom(this.x).tickSizeOuter(0));

      this.yAxis = (g) =>
        g
          .attr(
            "transform",
            "translate(" + this.margin_retire_age_bar.left + ",0)"
          )
          .call(d3.axisLeft(this.y));

      //   console.log("current gender", gender);
      this.data = this.current_retire_data.filter(
        (f) => f.gender === this.current_select_gender
      );
      // console.log("male data is ", this.data);

      this.y.domain([55, 75]).nice();
      // console.log("y",y(55))

      this.svg_retire_agr_bar
        .selectAll(".y-axis")
        .transition()
        .duration(this.draw_speed)
        .call(this.yAxis);

      // data.sort(d3.select("#sort").property("checked")
      //     ? (a, b) => b.value - a.value
      //     : (a, b) => years.indexOf(a.month) - months.indexOf(b.month))

      this.x.domain(this.data.map((d) => d.year));

      this.svg_retire_agr_bar
        .selectAll(".x-axis")
        .transition()
        .duration(this.draw_speed)
        .call(this.xAxis);

      this.bar = this.svg_retire_agr_bar
        .selectAll(".bar")
        .data(this.data, (d) => d.year);

      this.bar.exit().remove();

      this.bar_text = this.svg_retire_agr_bar
        .selectAll(".bartext")
        .data(this.data, (d) => d.year);

      this.bar_text.exit().remove();

      this.bar_text
        .enter()
        .append("text")
        .attr("class", "bartext")
        .merge(this.bar_text)
        .transition()
        .duration(this.draw_speed)
        .style("text-anchor", "middle")
        .attr("x", (d) => {
          return this.x(d.year) + this.x.bandwidth() / 2;
        })
        .attr("y", (d) => this.y(d.value) - 8)
        // .attr("y", d => height_retire_age - margin_retire_age_bar.bottom - y(d.value))
        // .attr("dy", ".2em")
        .text(function (d) {
          return d.value.toPrecision(3);
        })
        .style("font-size", "12");

      // const barEnter = this.bar.enter

      this.bar
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("width", this.x.bandwidth())
        .merge(this.bar)
        .transition()
        .duration(this.draw_speed)
        .attr("fill", ()=>{
          // console.log('???????this.current_select_gender is ',this.current_select_gender)
          return this.current_select_gender === "male"?this.color_for_male_bar:this.color_for_female_bar})
        .attr("x", (d) => this.x(d.year))
        .attr("y", (d) => this.y(d.value))
        .attr(
          "height",
          (d) =>
            this.height_retire_age -
            this.margin_retire_age_bar.bottom -
            this.y(d.value)
        );
    },

    redraw_retire_age_bar_chart(gender) {
      // console.log("current current_retire_data is", this.current_retire_data);
      this.x = d3
        .scaleBand()
        .range([
          this.margin_retire_age_bar.left,
          this.width_retire_age - this.margin_retire_age_bar.right,
        ])
        .padding(0.1)
        .paddingOuter(0.2);

      this.y = d3
        .scaleLinear()
        .range([
          this.height_retire_age - this.margin_retire_age_bar.bottom,
          this.margin_retire_age_bar.top,
        ]);

      this.xAxis = (g) =>
        g
          .attr(
            "transform",
            "translate(0," +
              (this.height_retire_age - this.margin_retire_age_bar.bottom) +
              ")"
          )
          .call(d3.axisBottom(this.x).tickSizeOuter(0));

      this.yAxis = (g) =>
        g
          .attr(
            "transform",
            "translate(" + this.margin_retire_age_bar.left + ",0)"
          )
          .call(d3.axisLeft(this.y));

      // console.log("current gender", gender);
      this.data = this.current_retire_data.filter((f) => f.gender === gender);
      // console.log("male data is ", this.data);

      this.y.domain([55, 75]).nice();
      // console.log("y",y(55))

      this.svg_retire_agr_bar

        .selectAll(".y-axis")
        .transition()
        .duration(this.draw_speed)
        .call(this.yAxis);

      // data.sort(d3.select("#sort").property("checked")
      //     ? (a, b) => b.value - a.value
      //     : (a, b) => years.indexOf(a.month) - months.indexOf(b.month))

      this.x.domain(this.data.map((d) => d.year));

      this.svg_retire_agr_bar
        .selectAll(".x-axis")
        .transition()
        .duration(this.draw_speed)
        .call(this.xAxis);

      this.bar = this.svg_retire_agr_bar
        .selectAll(".bar")
        .data(this.data, (d) => d.year);

      this.bar.exit().remove();

      this.bar
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("fill", "steelblue")
        .attr("width", this.x.bandwidth())
        .merge(this.bar)
        .transition()
        .duration(this.draw_speed)
        .attr("x", (d) => this.x(d.year))
        .attr("y", (d) => this.y(d.value))
        .attr(
          "height",
          (d) =>
            this.height_retire_age -
            this.margin_retire_age_bar.bottom -
            this.y(d.value)
        );
    },

    select(mode) {
      if (mode === "#labor-japan-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[0])
        );
      } else if (mode === "#labor-italy-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[1])
        );
      } else if (mode === "#labor-france-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[2])
        );
      } else if (mode === "#labor-spain-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[3])
        );
      } else if (mode === "#labor-uk-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[4])
        );
      } else if (mode === "#labor-canada-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[5])
        );
      } else if (mode === "#labor-us-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[6])
        );
      } else if (mode === "#labor-australia-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[7])
        );
      } else if (mode === "#labor-china-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[8])
        );
      } else if (mode === "#labor-turkey-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[9])
        );
      } else if (mode === "#labor-mexico-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[10])
        );
      } else if (mode === "#labor-finland-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[11])
        );
      } else if (mode === "#labor-iceland-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[12])
        );
      } else if (mode === "#labor-chile-btn") {
        this.current_retire_data = JSON.parse(
          JSON.stringify(this.data_retire_age_by_country[13])
        );
      }
      this.select_mode = mode;
    },

    //methods end
  },
};
</script>


<style scoped>
</style>